/**
 * @generated SignedSource<<8d21f4ec4e2f9ab5d2b0f4c3611d591a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topStoriesBlockQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"topStoriesItemContent">;
  };
  readonly " $fragmentType": "topStoriesBlockQueueItemsEdge";
}>;
export type topStoriesBlockQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: topStoriesBlockQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"topStoriesBlockQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "topStoriesBlockQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "topStoriesItemContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "846bd0bc7cfc01f1e6c0d2069b700585";

export default node;
